import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Select2Multiple from 'v-select2-multiple-component';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import axios from "axios";
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import CONFIG from "@/assets/js/config.js";
import store from '../../store';

export default {
  name: "assignmentList",
  components: {
    MainLayout,
    Select2Multiple,
    AdvancedLaravelVuePaginate,
    flatPickr,
    Loading,
    CONFIG
  },

  data() {
    return {
      noDataMsg: CONFIG.NO_DATA_FOUND,
      isLoading: false,
      assignmentList: {},
      searchData: {
        academic_year: 0,
        class_id: 0,
        subject_id: 0,
        assignment_title: '',
        teacher_name: '',
        from_date: null,
        to_date: null
      },
      academicYearArr: [],
      classArr: [],
      subjectArr: [],
      selectedYear: 0,
      selectedClass: 0,
      selectedSubject: 0,
      search_status: false,
    };
  },

  methods: {
    reset() {
      this.searchData = {
        academic_year: 0,
        class_id: 0,
        subject_id: 0,
        assignment_title: '',
        teacher_name: '',
        from_date: null,
        to_date: null
      };
      this.selectedYear = 0;
      this.classArr = [];
      this.subjectArr = [];
      this.isLoading = true;
      this.getAssignmentList();
    },

    getAcademicYear() {
      axios.get('getAcademicYear', {
        params: {
          campus_id: store.state.user.campus_id
        }
      })
        .then(res => {
          let $defaultSelectOption = [{
            'id': 0,
            'text': 'Select Academic Year'
          }];
          this.academicYearArr = $defaultSelectOption.concat(res.data.academicYearArr);
          this.getClass(this.selectedYear);
        }).catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
          console.log("Academic Year API Error", error);
        });
    },

    getClass($yearId) {
      axios.get("class/classList/" + $yearId, {
        params: {
          campus_id: store.state.user.campus_id
        }
        })
        .then(res => {
          let $defaultSelectOption = [{
            'id': 0,
            'text': 'Select Class'
          }];
          this.classArr = $defaultSelectOption.concat(res.data);
          this.subjectArr = [];
          this.isLoading = false;
        }).catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
          console.log("Class API Error", error);
        });
    },

    getSubjectByClassId($classId) {
      axios.get("/class/subjectByClassId/" + $classId, {
        params: {
          campus_id: store.state.user.campus_id,
          acd_year_id: this.selectedYear
        }
      })
      .then((response) => {
        let $defaultSelectOption = [{
          'id': 0,
          'text': 'Select Subject'
        }];
        this.subjectArr = $defaultSelectOption.concat(response.data.subjectArr[0]);
        this.isLoading = false;
      })
      .catch((error) => {
        if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
        }
        this.isLoading = false;
        console.log("Subject API Error", error);
      });
    },

    changeEvent(val, fieldName) {
      this.$set(this.searchData, fieldName, val);
      if (fieldName == "academic_year") {
          this.selectedClass = 0;
          this.searchData.class_id = 0;
          this.searchData.subject_id = 0;
          this.selectedSubject = 0;
          this.classArr = [];
          this.getClass(val);
      }
      if (fieldName == "class_id") {
          this.selectedSubject = 0; 
          this.searchData.subject_id = 0; 
          this.subjectArr = [];
          this.getSubjectByClassId(val);
      }
    },

    selectEvent({ id }, fieldName) {
      this.$set(this.searchData, fieldName, id == 'Select' ? 0 : id)
    },

    getAssignmentList(page = 1) {
      var request = {
        params: {
          user_id: store.state.user.id,
          user_type: 'admin',
          campus_id: store.state.user.campus_id,
        }
      }
      axios.get("/assignment/list?page=" + page, request)
        .then(response => {
          this.search_status = false;
          this.assignmentList = response.data;
          this.isLoading = false;
        })
        .catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
          console.log("Assignment List API Error", error);
        });
    },

    searchAssignment(page = 1) {
      this.isLoading = true;
      var request = {
        params: {
          user_id: store.state.user.id,
          user_type: 'admin',
          campus_id: store.state.user.campus_id,
          title: this.searchData.assignment_title,
          teacher_name: this.searchData.teacher_name,
          acd_year_id: this.normalize(this.searchData.academic_year),
          class_id: this.normalize(this.searchData.class_id),
          subject_id: this.normalize(this.searchData.subject_id),
          from_date: this.searchData.from_date,
          to_date: this.searchData.to_date
        }
      }
      axios.get("/assignment/search?page=" + page, request)
        .then(response => {
          this.search_status = true;
          this.assignmentList = response.data;
          this.isLoading = false;
        })
        .catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
          console.log("Assignment Search API Error", error);
        });
    },

    normalize(value) {
      return (value === 0 || value === '0') ? null : value
    },

    confirmDelete(assignmentId) {
      if (window.confirm("Are you sure you want to delete?")) {
        this.deleteAssignment(assignmentId);
      }
    },

    deleteAssignment(assignmentId) {
      axios.delete("/assignment/delete/" + assignmentId)
        .then(response => {
          if (response.data) {
            this.isLoading = true;
            this.getAssignmentList();
            this.$notification.success('Assignment Deleted Successfully', {
                timer: 3,
                position: "bottomCenter"
            });
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
          console.log("Assignment Delete Error->", error.response.data);
        });
    },

    showCreate() {
      this.$router.push({
        path: "/assignment/create"
      });
    },

    showEdit(assignmentId) {
      this.$router.push({
        name: "assignmentEdit",
        params: {
          id: assignmentId
        }
      });
    },

    showDetail(assignmentId) {
      this.$router.push({
        name: "assignmentDetail",
        params: {
          id: assignmentId
        }
      });
    },
  },

  mounted() {
    this.isLoading = true;
    this.getAcademicYear();
    this.getAssignmentList();
  },
};
